export default "__VITE_ASSET__fa8d8553__"